import { CharityRoute } from "../types/CharityRouteEnum";

/** Header routes withdrawn once the campaign has closed: both lead to a form it no longer takes. */
export const CAMPAIGN_CLOSED_WITHDRAWN_ROUTES: CharityRoute[] = [CharityRoute.Join, CharityRoute.Report];

/** Heading for every closed-campaign surface: the campaign page notice, and the join and report pages. */
export const CAMPAIGN_CLOSED_TITLE = "Ride to Rebuild has closed";

/**
 * Why the join and report pages no longer show their forms.
 *
 * States what stays open — the household's own rides — so a returning
 * participant knows where their miles are rather than only what has ended.
 */
export const CAMPAIGN_CLOSED_PARTICIPATION_NOTE =
  "Thank you to every household that rode. Reporting and new households have closed, and every ride you reported is still in your household's rides.";

/** Label on the closed panel's way back to the campaign page and its final figures. */
export const CAMPAIGN_CLOSED_SEE_TOTAL_LABEL = "See the final total";

/** Heading of the progress section once its figure is final. */
export const CAMPAIGN_CLOSED_PROGRESS_HEADING = "How much we raised";

/** Heading of the progress section while rides are still being added. */
export const CAMPAIGN_RUNNING_PROGRESS_HEADING = "How much we raised so far";

/** Heading of the latest-rides section once the campaign has closed. */
export const CAMPAIGN_CLOSED_RIDING_HEADING = "Families rode";

/** Heading of the latest-rides section while the campaign runs. */
export const CAMPAIGN_RUNNING_RIDING_HEADING = "Families are riding";

/** Words after the tracker's raised figure once it is final. */
export const CAMPAIGN_CLOSED_RAISED_SUFFIX = "raised";

/** Words after the tracker's raised figure while rides are still being added. */
export const CAMPAIGN_RUNNING_RAISED_SUFFIX = "raised so far";

/** Tally label for the household count once the campaign has closed. */
export const CAMPAIGN_CLOSED_HOUSEHOLDS_LABEL = "Households rode";

/** Tally label for the household count while the campaign runs. */
export const CAMPAIGN_RUNNING_HOUSEHOLDS_LABEL = "Households riding";
